import { combineReducers } from 'redux';
import events from './tasks.reducers';

const reducer = combineReducers({
	events
});

export default reducer;
